/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnpinStoryMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String'];
}>;


export type UnpinStoryMutation = { __typename: 'Mutation', unpinStory: { __typename: 'Campaign', id: string | null } | null };


export const UnpinStoryDocument = gql`
    mutation unpinStory($projectId: String!) {
  unpinStory(projectId: $projectId) {
    id
  }
}
    `;
export type UnpinStoryMutationFn = Apollo.MutationFunction<UnpinStoryMutation, UnpinStoryMutationVariables>;

/**
 * __useUnpinStoryMutation__
 *
 * To run a mutation, you first call `useUnpinStoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpinStoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpinStoryMutation, { data, loading, error }] = useUnpinStoryMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUnpinStoryMutation(baseOptions?: Apollo.MutationHookOptions<UnpinStoryMutation, UnpinStoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpinStoryMutation, UnpinStoryMutationVariables>(UnpinStoryDocument, options);
      }
export type UnpinStoryMutationHookResult = ReturnType<typeof useUnpinStoryMutation>;
export type UnpinStoryMutationOptions = Apollo.BaseMutationOptions<UnpinStoryMutation, UnpinStoryMutationVariables>;